import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';
import { CourseLevel } from 'src/common/models/course';

export interface CourseLevelIconProps extends IconProps {
  level?: CourseLevel;
}

const CourseLevelIcon = ({ level = CourseLevel.Beginner, ...props }: CourseLevelIconProps) => (
  <IconBox {...props}>
    <path
      clipRule="evenodd"
      fill="#B71833"
      fillRule="evenodd"
      d="M10.5556 42.6665c1.9636 0 3.5555 1.5919 3.5555 3.5556v14.2222c0 1.9637-1.5919 3.5555-3.5555 3.5555C8.59188 63.9998 7 62.408 7 60.4443V46.2221c0-1.9637 1.59188-3.5556 3.5556-3.5556z"
    />
    <path
      clipRule="evenodd"
      fill={level === CourseLevel.Beginner ? undefined : '#B71833'}
      fillRule="evenodd"
      d="M31.8895 21.3335c1.9637 0 3.5556 1.5919 3.5556 3.5556v35.5555c0 1.9637-1.5919 3.5556-3.5556 3.5556-1.9636 0-3.5555-1.5919-3.5555-3.5556V24.8891c0-1.9637 1.5919-3.5556 3.5555-3.5556z"
    />
    <path
      clipRule="evenodd"
      fill={level === CourseLevel.Advanced ? '#B71833' : undefined}
      fillRule="evenodd"
      d="M53.2216 0c1.9637 0 3.5555 1.59188 3.5555 3.55556V60.4444c0 1.9637-1.5918 3.5556-3.5555 3.5556-1.9637 0-3.5556-1.5919-3.5556-3.5556V3.55556C49.666 1.59188 51.2579 0 53.2216 0z"
    />
  </IconBox>
);

export default CourseLevelIcon;
